import request from "@/utils/request";
import { getToken } from "@/utils/auth"; // 验权

export function getInfo() {
  return request({
    url: "/role/showMenuTree",
    method: "get",
    header: {
      token: getToken()
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js